import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import contentToText from "../../utils/contentToText";
import { isCordovaApp } from "../../utils/cordovaUtils";

const ChapterMeta = ({ bible, chapter }) => {
  if (isCordovaApp) {
    return null;
  }
  if (!bible || !chapter || !chapter.content) {
    return null;
  }
  const description = contentToText(chapter.content, 160);
  const title = `${chapter.reference} - ${bible.name} - ${bible.abbreviation}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="og:title" content={title} />
      <meta name="description" content={description} />
      <meta
        name="keywords"
        content={[
          bible,
          chapter.reference,
          chapter.id,
          bible.name,
          bible.nameLocal,
          bible.abbreviation,
          bible.abbreviationLocal,
          bible.description,
          bible.language.name,
          bible.language.id
        ].join(",")}
      />
    </Helmet>
  );
};

ChapterMeta.propTypes = {
  bible: PropTypes.shape({
    name: PropTypes.string,
    nameLocal: PropTypes.string,
    abbreviation: PropTypes.string,
    abbreviationLocal: PropTypes.string,
    description: PropTypes.string,
    language: PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string
    })
  }),
  chapter: PropTypes.shape({
    reference: PropTypes.string,
    id: PropTypes.string
  })
};

ChapterMeta.defaultProps = {
  bible: null,
  chapter: null
};

export default ChapterMeta;
